import type { ApiClient } from '../client/api-client';
import type * as Contracts from '../contracts/index';
import type {
  AdminCommandDto,
  ApproveWithdrawalPayload,
  CreateEmergencyGrantPayload,
} from '../contracts/rbac';
import type { WithdrawalAdminDto } from '../contracts/index';

export function createRbacService(client: ApiClient) {
  return {
    listEmergencyGrants: (withdrawalId: string) =>
      client.get<{ data: Contracts.EmergencyGrantDto[] }>(
        `/app/v1/admin/withdrawal-emergencies?withdrawalId=${encodeURIComponent(withdrawalId)}`,
      ),
    createEmergencyGrant: (payload: CreateEmergencyGrantPayload) =>
      client.post<Contracts.EmergencyGrantDto | { withdrawal: WithdrawalAdminDto; grant: Contracts.EmergencyGrantDto }>(
        '/app/v1/admin/withdrawal-emergencies',
        payload,
      ),
    revokeEmergencyGrant: (id: string, payload: AdminCommandDto) =>
      client.post<Contracts.EmergencyGrantDto>(`/app/v1/admin/withdrawal-emergencies/${encodeURIComponent(id)}/revoke`, payload),
    approveWithdrawal: (id: string, payload: ApproveWithdrawalPayload = {}) =>
      client.post<WithdrawalAdminDto>(`/app/v1/withdrawals/admin/${encodeURIComponent(id)}`, payload),
  };
}

export type RbacService = ReturnType<typeof createRbacService>;
